import { render, staticRenderFns } from "./service_detail.vue?vue&type=template&id=ac1a0c0c&scoped=true"
import script from "./service_detail.vue?vue&type=script&lang=js"
export * from "./service_detail.vue?vue&type=script&lang=js"
import style0 from "./service_detail.vue?vue&type=style&index=0&id=ac1a0c0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac1a0c0c",
  null
  
)

export default component.exports